
import { ApiService } from 'src/app/services/api.service';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HeaderComponent } from "../header/header.component";
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { LocalstorageService } from 'src/app/services/localstorage.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [HeaderComponent, CommonModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {

  signupForm: FormGroup
  loginForm: FormGroup
  setPassword: boolean = false
  buttonLabel: string = 'Validate'
  enablePassword: boolean = false
  isPasswordVisible: boolean = false
  currentUser = {
    email: '',
    employeeCode: '',
    setPassword: false
  }
  errorLabel: string = ''

  constructor(private apiService: ApiService, private formBuilder: FormBuilder, private route: Router, private localStorageService: LocalstorageService) {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['']
    })

    this.signupForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      employeeCode: ['', Validators.required],
      password: ['', Validators.required]
    })

  }
  ngOnInit(): void {
    this.currentUser = this.localStorageService.getEmployeeDetails()
    this.currentUser.email ? this.signupForm.get('email')?.setValue(this.currentUser.email) : ''
    this.currentUser.email ? this.signupForm.get('employeeCode')?.setValue(this.currentUser.employeeCode) : ''
    this.currentUser.setPassword ? this.setPassword = true : ''
  }

  enableSingUp(event: Event) {
    event.preventDefault()
    this.setPassword = true
  }

  togglePassword(elementName: string) {
    this.isPasswordVisible = !this.isPasswordVisible;
    const passwordInput = document.getElementById(elementName) as HTMLInputElement;
    if (passwordInput) {
      passwordInput.type = this.isPasswordVisible ? 'text' : 'password';
    }
  }

  validateLogin() {
    const loginDetails = {
      email: this.loginForm.get('email')?.value,
      password: this.loginForm.get('password')?.value
    }

    if(loginDetails.password === '') {
      this.apiService.validateEmailForVerification(loginDetails.email).subscribe(
        (res: any) => {
          this.apiService.validateEmailForSignUp(loginDetails.email).subscribe(
            (res: any) => {
              console.log(res)
              this.enablePassword = true
              this.buttonLabel = 'Login'
            },
            (error: any) => {
              this.setPassword = true
            }
          );
        },
        (error: any) => {
          this.route.navigate(['/welcome'])
        }
      );
    } else {
      this.apiService.loginWithExisting(loginDetails).subscribe(
        (res: any) => {
          this.route.navigate(['/home'])
          this.localStorageService.setEmailInLocalStorage(this.loginForm.get('email')?.value)
        },
        (error: any) => {
          console.log(error)
          this.errorLabel = 'Incorrect email or password'
        }
      );
    }
  }

  signupUser() {
    const signUpDetails = {
      employeeCode: this.signupForm.get('employeeCode')?.value,
      email: this.signupForm.get('email')?.value,
      password: this.signupForm.get('password')?.value,
    }
    this.apiService.signUpAsNewUser(signUpDetails).subscribe(
      (res: any) => {
        console.log(res)
        this.localStorageService.setEmailInLocalStorage(signUpDetails.email)
        this.route.navigate(['/home'])
      },
      (error: any) => console.log(error)
    );
  }
}
